module.exports = __webpack_public_path__ + "img/icon-sliders.08b1fc66.svg";